<template>
  <div>
    <b-row class="align-items-end">
      <b-col md="6" lg="">
        <InputQuantity
          id="irPercentage"
          labelBold
          label="Alíquota de IR"
          :prefix="false"
          :precision="4"
          :max="8"
          v-model="nfseConfigurations.irPercentage"
        />
      </b-col>
      <b-col md="6" lg="">
        <InputQuantity
          id="csllPercentage"
          labelBold
          label="Alíquota de CSLL"
          :prefix="false"
          :precision="4"
          :max="8"
          v-model="nfseConfigurations.csllPercentage"
        />
      </b-col>
      <b-col md="6" lg="">
        <InputQuantity
          id="inssPercentage"
          labelBold
          label="Alíquota de INSS"
          :prefix="false"
          :precision="4"
          :max="8"
          v-model="nfseConfigurations.inssPercentage"
        />
      </b-col>
      <b-col md="6" lg="">
        <InputQuantity
          id="cofinsPercentage"
          labelBold
          label="Alíquota de COFINS"
          :prefix="false"
          :precision="4"
          :max="8"
          v-model="nfseConfigurations.cofinsPercentage"
        />
      </b-col>
      <b-col md="6" lg="">
        <InputQuantity
          id="pisPercentage"
          labelBold
          label="Alíquota de PIS"
          :prefix="false"
          :precision="4"
          :max="8"
          v-model="nfseConfigurations.pisPercentage"
        />
      </b-col>
      <b-col md="6" lg="" class="text-center">
        <b-row>
          <b-col><Label>Subtrair Tributos</Label></b-col>
        </b-row>
        <b-row>
          <b-col
            ><CheckboxSwitch
              id="subtractTributes"
              v-model="nfseConfigurations.subtractTributes"
              :tooltipPosition="'bottom'"
          /></b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { InputQuantity, CheckboxSwitch, Label } from '@/components';
import { mapState } from 'vuex';

export default {
  name: 'Tributes',
  components: { InputQuantity, CheckboxSwitch, Label },
  computed: {
    ...mapState('nfseConfigurations', ['nfseConfigurations']),
  },
};
</script>
